import React, { memo, Fragment, useCallback, useMemo } from 'react';
import { createUseStyles, RadioBoxGroup } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import { ENTITIES } from 'lib/constants';

import StepContent from '../StepContent';
import UpdateOptions from './UpdateOptions';
import IdentifierPicker from './IdentifierPicker';
import { ENTITIES_DATA } from '../../constants';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ImportType');

const ImportType = ({
    entityName,
    entityLabel,
    data,
    matchBy,
    advancedType,
    imgImportsName,
    imgImportsFmId,
    imgImportsExtId,
    onClickIsAdvanced,
    onClickIdentifier,
    onChangeIdType,
    onChangeSyncNames,
    syncNamesList,
    onChangeImportType,
    totals,
}) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const getIdentifierPicker = useCallback(
        ({ withMarginTop, newAdvancedType }) => {
            if (
                entityName !== ENTITIES.CONTACTS.name &&
                entityName !== ENTITIES.OPPORTUNITIES.name
            ) {
                return;
            }

            return (
                <IdentifierPicker
                    setIsAdvanced={(bool) => onClickIsAdvanced(bool, newAdvancedType)}
                    isAdvanced={advancedType && advancedType === newAdvancedType}
                    setIdentifier={onClickIdentifier}
                    identifier={matchBy}
                    withMarginTop={withMarginTop}
                    imgImportsName={imgImportsName}
                    imgImportsFmId={imgImportsFmId}
                    imgImportsExtId={imgImportsExtId}
                />
            );
        },
        [
            entityName,
            matchBy,
            advancedType,
            onClickIsAdvanced,
            onClickIdentifier,
            imgImportsName,
            imgImportsFmId,
            imgImportsExtId,
        ],
    );

    const children = useMemo(() => {
        return (
            <>
                <UpdateOptions
                    idType={data.idType}
                    onChangeIdType={onChangeIdType}
                    syncNames={syncNamesList}
                    onChangeSyncNames={onChangeSyncNames}
                    fields={data.fields}
                    entityLabel={entityLabel}
                />
                {getIdentifierPicker({ withMarginTop: true, newAdvancedType: 'update' })}
            </>
        );
    }, [
        data.fields,
        data.idType,
        onChangeIdType,
        onChangeSyncNames,
        syncNamesList,
        getIdentifierPicker,
        entityLabel,
    ]);

    const options = useMemo(() => {
        const totalOptions = [
            {
                icon: ENTITIES_DATA[entityName]?.addIcon || 'valueListAdd',
                title: t('cfm_label_import_type_create', [entityLabel]),
                text: t('cfm_label_import_type_create_subtitle', [entityLabel]),
                value: 'create',
                className: 'import-export__import-type--create',
                children: getIdentifierPicker({ newAdvancedType: 'create' }),
            },
        ];
        if (totals)
            totalOptions.push({
                icon: ENTITIES_DATA[entityName]?.editIcon || 'valueListEdit',
                title: t('cfm_label_import_type_update', [entityLabel]),
                text: t('cfm_label_import_type_update_subtitle', [entityLabel]),
                value: 'update',
                className: 'import-export__import-type--update',
                children,
            });
        return totalOptions;
    }, [entityName, t, entityLabel, getIdentifierPicker, children, totals]);

    return (
        <Fragment>
            <div className={classes.stepWrapper}>
                <StepContent>
                    <RadioBoxGroup
                        className={classes.importTypeBox}
                        options={options}
                        onChange={onChangeImportType}
                        value={data.importType}
                    />
                </StepContent>
            </div>
        </Fragment>
    );
};

ImportType.propImportTypes = {};

export default memo(ImportType);
